import { render, staticRenderFns } from "./WebMobileEdit.vue?vue&type=template&id=2f60a774&scoped=true&"
import script from "./WebMobileEdit.vue?vue&type=script&lang=js&"
export * from "./WebMobileEdit.vue?vue&type=script&lang=js&"
import style0 from "./WebMobileEdit.vue?vue&type=style&index=0&id=2f60a774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f60a774",
  null
  
)

export default component.exports